import { render, staticRenderFns } from "./EditGroupCustomFieldsModal.vue?vue&type=template&id=96776f94&scoped=true&"
import script from "./EditGroupCustomFieldsModal.vue?vue&type=script&lang=js&"
export * from "./EditGroupCustomFieldsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96776f94",
  null
  
)

export default component.exports